import { deepClone } from './clone';
import type { Ruleset, RulesetOverrides } from './types';

export const DEFAULT_RULESET: Ruleset = {
  addons: { sea: true, vocations: true, bosses: true },
  temples: false,
  minPlayers: 3,
  maxPlayers: 6,
  maxBots: 5,
  startingTroops: { 3: 30, 4: 25, 5: 21, 6: 18 },
  setupBatch: 3,
  minReinforcements: 3,
  territoriesPerReinforcement: 2,
  tradeValues: [4, 6, 8, 10, 12, 15],
  tradeIncrement: 5,
  mandatoryTradeHand: 5,
  maxAttackDice: 3,
  maxDefenseDice: 3,
  seaMaxDice: 2,
  bossSpawnFaces: [5, 6],
  strengthBonus: 1,
  reinforceLootTroops: 3,
  lootCopies: 1,
  maxLoot: 3,
  strikeDamage: 2,
  barrageTargets: 3,
  restoreTroops: 3,
  drawCards: 2,
  bossDamagePerCard: 2,
  firstRegionLoot: 1,
  reactionTimeoutMs: 10_000,
  serverSaveRound: 10,
  scorePerTerritory: 1,
  scorePerRegion: 3,
  scorePerBossKill: 2,
  fallbackMissionTerritories: 10,
  era: null,
  truceRounds: 0,
  bounty: false,
  skullConquests: 0,
  coordinationBonus: 0,
  harmonyMax: 5,
  harmonyMin: 3,
  harmonyPerTurn: 2,
};

export function resolveRuleset(overrides?: RulesetOverrides): Ruleset {
  const base = deepClone(DEFAULT_RULESET);
  if (!overrides) return base;
  const { addons, ...rest } = overrides;
  return {
    ...base,
    ...rest,
    addons: { ...base.addons, ...(addons ?? {}) },
  } as Ruleset;
}
